import { useSearchParams } from 'react-router-dom';

export function useTabParam<K extends string>(tabs: readonly K[], fallback: K): [K, (tab: K) => void] {
  const [params, setParams] = useSearchParams();
  const raw = params.get('tab');
  const tab = tabs.find((t) => t === raw) ?? fallback;
  const setTab = (next: K) => {
    setParams(
      (current) => {
        const updated = new URLSearchParams(current);
        if (next === fallback) updated.delete('tab');
        else updated.set('tab', next);
        return updated;
      },
      { replace: true },
    );
  };
  return [tab, setTab];
}
